import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import Partnership from "../home/partnership/Partnership";

export default function PartnershipPage() {
  return (
    <>
      <Header />
      <Partnership />
      <Footer />
    </>
  );
}
